<template>
  <div class="idf-contact-card">
    <div class="idf-contact-card__infos">
      <strong class="idf-contact-card__name">{{ firstName }} {{ lastName }}</strong>
      <p v-if="description" class="idf-contact-card__description">
        {{ description }}
      </p>
      <p class="idf-contact-card__phone">
        {{ phone }}
      </p>
      <p class="idf-contact-card__email">
        {{ email }}
      </p>
    </div>
    <adn-call-to-phone v-if="phone" class="idf-contact-card__icon" :phone-number="phone" :sms="false" />
    <adn-call-to-phone v-if="phone" class="idf-contact-card__icon" :phone-number="phone" :sms="true" />
  </div>
</template>

<script>
import AdnCallToPhone from '../AdnCallToPhone/AdnCallToPhone.vue'

export default {
  name: 'IdfContactCard',
  components: {
    AdnCallToPhone,
  },
  props: {
    firstName: {
      type: String,
    },
    lastName: {
      type: String,
    },
    description: {
      type: String,
      default: null,
    },
    phone: {
      type: String,
    },
    email: {
      type: String,
    },
  },
}
</script>
<style scoped lang="scss">
.idf-contact-card {
  display: block;
  background: var(--color-background-light);
  border-radius: var(--border-radius-2);
  border: 1px solid var(--color-border-light);
  padding: 20px;
  align-items: center;
  text-align: center;

  @media (min-width: ($breakpoint-lg)) {
    display: flex;
    text-align: initial;
  }
}

.idf-contact-card__infos {
  margin-bottom: var(--spacing-3);

  @media (min-width: ($breakpoint-lg)) {
    width: 25rem;
    margin-right: var(--spacing-3);
    margin-bottom: 0;
  }
}

.idf-contact-card__icon {
  margin: 0 20px;
  display: inline-flex;
}

.idf-contact-card__button {
  text-align: left;
  margin: 0 auto 1em;
  max-width: 250px;
  display: block;
}

.idf-contact-card__email {
  word-break: break-all;
}
</style>
